export const legalDocumentLocale = (language: string): 'zh' | 'en' =>
  language.toLowerCase().startsWith('zh') ? 'zh' : 'en';

export const withLegalDocumentLocale = (href: string, language: string): string => {
  try {
    const url = new URL(href, 'https://accounts.aletyn.com');
    url.searchParams.set('locale', legalDocumentLocale(language));
    return href.startsWith('http://') || href.startsWith('https://')
      ? url.toString()
      : `${url.pathname}${url.search}${url.hash}`;
  } catch {
    const separator = href.includes('?') ? '&' : '?';
    return `${href}${separator}locale=${legalDocumentLocale(language)}`;
  }
};
